<template>
  <!-- 奖品管理-价格配置 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false"
      :title="dialogType === 1 ? '添加价格配置' : '编辑价格配置'" width="450px" @close="closeDialog">
      <el-form :model="formData" v-if="formData" ref="formData" label-width="80px" size="small" :rules="taskRules">
        <el-form-item prop="type" label="类型">
          <el-select v-model="formData.type" placeholder="请选择类型">
            <el-option :value="1" label="普通盒子"></el-option>
            <el-option :value="2" label="热血盲盒"></el-option>
            <el-option :value="3" label="商城"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="min_price" label="价格范围">
          <el-input style="width:150px" v-model="formData.min_price" placeholder="请输入最低价格"></el-input>
          -
          <el-input style="width:150px" v-model="formData.max_price" placeholder="请输入最高价格"></el-input>
        </el-form-item>
        <el-form-item prop="lowest_nums" label="最低个数">
          <el-input v-model="formData.lowest_nums" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item prop="premium_rate" label="溢价">
          <el-input v-model="formData.premium_rate" placeholder="请输入溢价(0-1之间的小数)"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="formData.status" placeholder="状态">
            <el-option :value="1" label="开启"></el-option>
            <el-option :value="0" label="关闭"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeDialog: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {//表单
        type: '',
        premium_rate: '',
        lowest_nums: '',
        status: 0,
        min_price: '',
        max_price: '',
      },
      taskRules: {//表单验证
        cycle: [
          {
            required: true,
            message: '请选择任务类型',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    DialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeDialog
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.DialogInfo) {
        this.formData = this.DialogInfo
      }

    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData

          if (this.dialogType == 1) {
            postApiData('goods_premium', params).then(res => {
              this.$message.success(res.message)
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType == 2) {
            patchApiData(`goods_premium/${params.id}`, params).then(res => {
              this.$message.success(res.message)
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
      setTimeout(() => {
        if (this.dialogType == 2) {
          this.formData = {//还原任务表单
          }
        }
      }, 500)
    }
  }

}
</script>
<style lang="less" scoped>

</style>